import _ from 'lodash'
import {
    getMappedSeverity,
    getToasts as getToastsImport,
    getMotds as getMotdsImport,
} from './toasts/selectors'
import {
    getActiveQueue as getActiveQueueImport,
    getButtonEnabled as getButtonEnabledImport,
    getVisible as getVisibleImport,
} from './queue/selectors'
import {
    getLanguage as getLanguageImport,
    getAscending as getAscendingImport,
    getMaxToShow as getMaxToShowImport,
    getTimeoutBarVisibility as getTimeoutBarVisibilityImport,
    getRequestCountVisibility as getRequestCountVisibilityImport,
} from './settings/selectors'

const queues = {
    getActiveQueue: state => getActiveQueueImport(state.queue),
    getButtonEnabled: state => getButtonEnabledImport(state.queue),
    getVisible: state => getVisibleImport(state.queue),
}

const settings = {
    getLanguage: state => getLanguageImport(state.settings),
    getAscending: state => getAscendingImport(state.settings),
    getMaxToShow: state => getMaxToShowImport(state.settings),
    getTimeoutBarVisibility: state => getTimeoutBarVisibilityImport(state.settings),
    getRequestCountVisibility: state => getRequestCountVisibilityImport(state.settings),
}

const toasts = {
    getMotds: state => getMotdsImport(state.toasts),
    getToasts: (state) => {
        // First get the toasts that have not been dismissed and are visible
        const data = getToastsImport(state.toasts)

        // Now filter away the ones in the wrong queue
        const queue = getActiveQueueImport(state.queue)
        const locale = getLanguageImport(state.settings)
        const ascending = getAscendingImport(state.settings)

        let result = data.reduce((res, toast) => {
            if (toast.queue !== queue.name && !toast.alwaysOnTop) {
                return res
            }
            const newToast = {
                id: toast.id,
                title: toast.localized[locale].title,
                content: toast.localized[locale].content,
                isMessage: toast.isMessage,
                timeout: toast.timeout,
                timeoutBar: getTimeoutBarVisibilityImport(state.settings),
                type: getMappedSeverity(toast.severity),
                counts: {
                    total: toast.count,
                    sinceLast: toast.countSinceLastDismissal,
                },
                showCounter: getRequestCountVisibilityImport(state.settings),
            }
            res.push(newToast)
            return res
        }, [])

        if (ascending) {
            result = _.reverse(result)
        }

        // Finally pick the first X messages
        return result.slice(0, getMaxToShowImport(state.settings))
    },
}

// eslint-disable-next-line
export const selectors = { queue: queues, settings, toasts }



// WEBPACK FOOTER //
// ./src/features/Toaster/data/selectors.js